import React from "react";
import FaqLabel from "../../../components/faq-label/faq-label/faq-labe.component";
import "./faq-content.styles.css";

const FaqContent = () => {


    const FaqCategory = [
      {
        id: 1,
        qusetion: 'چگونه می‌توانم سفارشم را پیگیری کنم؟',
        answer:
          'با ورود به حساب کاربری خود و مراجعه به بخش سفارشات من، می‌توانید وضعیت سفارش خود را مشاهده کنید',
      },
      {
        id: 2,
        qusetion: 'آیا امکان تعویض یا بازگشت کالا وجود دارد؟',
        answer:
          'بله، شما می‌توانید تا 7 روز پس از دریافت کالا درخواست تعویض یا بازگشت دهید، به شرطی که کالا استفاده نشده باشد.',
      },
      {
        id: 3,
        qusetion: 'روش‌های ارسال سفارش چگونه است؟',
        answer:
          'سفارشات از طریق پست پیشتاز یا پیک (برای شهرهای بزرگ) ارسال می‌شوند. زمان تحویل بین 2 تا 5 روز کاری است.',
      },
      {
        id: 4,
        qusetion: 'آیا می‌توانم سفارش خود را لغو کنم؟',
        answer:
          'بله، تا قبل از ارسال سفارش، می‌توانید آن را از طریق حساب کاربری خود لغو کنید.',
      },
      {
        id: 5,
        qusetion: 'چه روش‌های پرداختی در فروشگاه شما پشتیبانی می‌شود؟',
        answer:
          'پرداخت از طریق کارت‌های بانکی عضو شتاب و درگاه‌های امن آنلاین امکان‌پذیر است.',
      },
      {
        id: 6,
        qusetion: 'چگونه می‌توانم از تخفیف‌های شما باخبر شوم؟',
        answer:
          'ما سعی می‌کنیم در کمترین زمان ممکن به درخواست‌های شما پاسخ دهیم. معمولاً زمان پاسخگویی بین 24 تا 48 ساعت است.',
      },
      {
        id: 7,
        qusetion: 'آیا محصولات دارای ضمانت کیفیت هستند؟',
        answer:
          'بله، تمامی محصولات ما دارای ضمانت اصالت و کیفیت هستند و پیش از ارسال، مورد بررسی قرار می‌گیرند.',
      },
    ]

    return (
        <div className="faq-content">
            {FaqCategory.map((cat) => (
                <div key={cat.id} className="faq-label-container">
                    <FaqLabel category={cat} />
                </div>
            ))}
        </div>
    );
};

export default FaqContent;
